
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { searchEstablishmentsDropdown } from '../../../api/Establishment';
import { LabeledSelect } from '..';

export const SearchEstablishment = (
  { label, id, onChange, withAsterisks, value, disabled, isActiveOnly, setValueAsObject = false }
) => {
  const [ t ] = useTranslation();

  const [ Establishments, setEstablishmentsOptions ] = useState([]);
  const [ placeholder, setPlaceholder ] = useState(t('fields.search'));

  const [ { data }, fetchEstablishments ] = useFetch(searchEstablishmentsDropdown,
    useCallback(response => response?.data?.container));

  const onSearch = useCallback(username => {
    !!username && fetchEstablishments({ username, ...(isActiveOnly ? { isActiveOnly } : {}) });
  }, [ fetchEstablishments ]);

  useEffect(() => {
    if (data) {
      const options = Object.keys(data).map(item => ({ value: `${item}`, text: `${data[item]}` }));
      setEstablishmentsOptions(options);
    }
    if (data && data[value]) {
      setPlaceholder(data[value]);
    }
  }, [ data ]);

  return (
    <LabeledSelect
      label={ label }
      id={ id }
      setValueAsObject={ setValueAsObject }
      onChange={ onChange }
      showSearch={ true }
      withDebounceSearch={ true }
      onSearch={ onSearch }
      searchDelay={ 2000 }
      options={ Establishments }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatchedEstablishment') }
      withAsterisks={ withAsterisks }
      placeholder={ placeholder ?? value }
      value={ setValueAsObject ? value?.value : value }
      disabled={ disabled }
      data-testid={ id }
    />
  );
};
